export type FireOpenPaymentCountry = {
  code: string;
  description: string;
};

export type FireOpenPaymentCurrency = {
  code: string;
  description: string;
};

export class FireOpenPaymentAspsp {
  aspspUuid: string;
  alias: string;
  logoUrl: string;
  country: FireOpenPaymentCountry;
  currency: FireOpenPaymentCountry;
  dateCreated?: Date;
  lastUpdated?: Date;
}
